import { useState } from "react";
import { Button } from "@biteship/atom";
import ModalRatesForm from "../ModalRatesForm";
import ModalImportRates from "../ModalImportRates";
import ModalUploadStatus from "../ModalUploadStatus";

export default function Header(props) {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openImportModal, setOpenImportModal] = useState(false);
  const [openStatusModal, setOpenStatusModal] = useState(false);
  const [importRatesStatus, setImportRatesStatus] = useState([]);

  const onImportSubmit = (results) => {
    setImportRatesStatus(results);
    setOpenImportModal(false);
    setOpenStatusModal(true);
  };

  return (
    <div className="pb-6">
      <div className="flex space-x-3 justify-end">
        <Button
          onClick={() => setOpenImportModal(true)}
          title={<div className="font-bold flex items-center">Import Rates</div>}
          secondary
        />
        <Button
          onClick={() => setOpenCreateModal(true)}
          title={<div className="font-bold flex items-center">Tambah Rates</div>}
        />
      </div>
      <ModalRatesForm
        show={openCreateModal}
        onClose={() => setOpenCreateModal(false)}
        useType="create"
      />
      <ModalImportRates
        show={openImportModal}
        onClose={() => setOpenImportModal(false)}
        onSubmit={onImportSubmit}
      />
      <ModalUploadStatus show={openStatusModal} rates={importRatesStatus} />
    </div>
  );
}
